import { lazy } from 'react';

export const PlayerUpdateRgNetDepositLimitBlockForm = lazy(
  () => import('./PlayerUpdateRgNetDepositLimitBlockForm'),
);
